import * as breakpoints from "../../styles/breakpoints";
import * as colors from "../../styles/colors";
import * as docketPropTypes from "../../docketPropTypes";
import * as register from "../../lib/api/register";
import * as sessionActions from "../../actions/sessionActions";
import * as targetsActions from "../../actions/targetsActions";
import * as users from "../../lib/api/users";
import appStyles from "../../styles/appStyles";
import BorderedLoginTextField from "../BorderedLoginTextField";
import Checkbox from "../Checkbox";
import FormSubmitButton from "../FormSubmitButton";
import handleUnknownError from "../../lib/handleUnknownError";
import loginStyles from "../../styles/loginStyles";
import Navigator from "../Navigator";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import Unauthenticated from "../templates/Unauthenticated";
import { connect } from "react-redux";
import { StyleSheet, css } from "aphrodite/no-important";
import history from "../../lib/history";
import * as routeHelpers from "../../lib/routeHelpers";

const strings = {
	emailHint: "Email",
	header: "Login",
	passwordHint: "Password",
	rememberLabel: "Remember me",
	submitButtonLabel: "Sign in",
	title: "Docket Navigator - Login",
	validationMessage: "Email or password is incorrect.",
};

const styles = StyleSheet.create({
	footer: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
	},
	loginButton: {
		[breakpoints.portraitTabletAndDown]: {
			transition: "background-color 0s",
			backgroundColor: colors.transparent,
		},
	},
	emailTextField: {
		marginBottom: 24,
	},
	passwordTextField: {
		marginBottom: 17,
	},
	checkboxLabel: {
		color: colors.black,
		opacity: 0.54,
		marginLeft: 8,

		[breakpoints.portraitTabletAndDown]: {
			color: colors.docketLightishBlue,
			opacity: 1,
		},
	},
	checkboxIcon: {
		marginRight: 0,
		fill: colors.textGrey,

		[breakpoints.portraitTabletAndDown]: {
			fill: colors.docketLightishBlue,
		},
	},
	checkboxIconChecked: {
		fill: colors.docketLightishBlue,
	},
});

export const getLocalStorageLibraryName = () => {
	return JSON.parse(localStorage.getItem("libraryName"));
};

export class LoginPage extends PureComponent {
	static propTypes = {
		clearTargets: PropTypes.func.isRequired,
		location: docketPropTypes.routerLocation.isRequired,
		loginAndRedirect: PropTypes.func.isRequired,
		match: docketPropTypes.match.isRequired,
	};

	state = {
		email: __DEV__ ? "user55@docketnavigator.com" : "",
		formHasErrors: false,
		validationErrors: {},
		loading: false,
		password: __DEV__ ? "SecretPassword55" : "",
		rememberMe: false,
		localStorageLibraryName: getLocalStorageLibraryName() || "",
	};

	componentDidMount() {
		this.setState({ localStorageLibraryName: getLocalStorageLibraryName() || "" });
	}

	_setEmail = e => this.setState({ email: e.target.value });
	_setPassword = e => this.setState({ password: e.target.value });
	_toggleRememberMe = (e, isInputChecked) => this.setState({ rememberMe: isInputChecked });

	_submit = e => {
		e.preventDefault();
		if (this.state.loading) {
			return;
		}
		this.setState({ loading: true });
		register
			.login(this.state.email, this.state.password, this.state.rememberMe)
			.then(() => {
				this.props.clearTargets();
				return users.me();
			})
			.then(user => {
				if (this._mounted) {
					this.setState({ loading: false });
				}

				if (
					!!this.state.localStorageLibraryName &&
					!window.location.href.includes("destination=")
				) {
					this.props.loginAndRedirect(
						user,
						routeHelpers.getSearchPath(this.state.localStorageLibraryName),
					);
				} else {
					this.props.loginAndRedirect(user);
				}
			})
			.catch(err => {
				let validationErrors = {};
				if (err.validation) {
					validationErrors = err.validation;
				} else if (!err.handled) {
					handleUnknownError(err);
				}

				this.setState({
					loading: false,
					formHasErrors: true,
					validationErrors,
				});
			});
	};

	render() {
		return (
			<Unauthenticated>
				<Navigator
					location={this.props.location}
					params={this.props.match.params}
					title={strings.title}
				/>

				<div className={css(loginStyles.container)}>
					<h2 className={css(appStyles.baseFont, loginStyles.header)}>
						{strings.header}
					</h2>

					<p
						className={css(
							appStyles.baseFont,
							loginStyles.validationMessage,
							this.state.formHasErrors ? loginStyles.visible : null,
						)}
					>
						{strings.validationMessage}
					</p>

					<form method="post" onSubmit={this._submit}>
						<BorderedLoginTextField
							aStyles={styles.emailTextField}
							autoFocus={true}
							errored={this.state.formHasErrors}
							onChange={this._setEmail}
							placeholder={strings.emailHint}
							type="email"
							value={this.state.email}
							autoComplete={"username"}
						/>
						<BorderedLoginTextField
							aStyles={styles.passwordTextField}
							errored={this.state.formHasErrors}
							onChange={this._setPassword}
							placeholder={strings.passwordHint}
							type="password"
							value={this.state.password}
							autoComplete="current-password"
						/>

						<Checkbox
							aStylesIcon={styles.checkboxIcon}
							aStylesIconChecked={styles.checkboxIconChecked}
							aStylesLabel={styles.checkboxLabel}
							checked={this.state.rememberMe}
							label={strings.rememberLabel}
							onCheck={this._toggleRememberMe}
						/>

						<div className={css(styles.footer)}>
							<FormSubmitButton
								aStyles={styles.loginButton}
								disabled={this.state.loading}
								label={strings.submitButtonLabel}
								loading={this.state.loading}
							/>
						</div>
					</form>
				</div>
			</Unauthenticated>
		);
	}
}

export default connect(
	null,
	{
		clearTargets: targetsActions.clearTargets,
		loginAndRedirect: sessionActions.loginAndRedirect,
	},
)(LoginPage);
